<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="wrapper">
  <div class="search" *ngIf="displaySearch">
    <form class="form-inline my-2 my-lg-0 search-container">
      <input
        #searchInput
        class="form-control mr-sm-2 search-bar"
        type="search"
        placeholder="Search"
        aria-label="Search"
        [value]="searchValue"
        (keyup.enter)="getSearch(searchInput.value)"
        (focus)="focusFunction()"
      />
      <div class="search-icon" (click)="eraseSearch()" *ngIf="resetInput">
        <i class="material-icons">delete_outline</i>
      </div>
      <div class="search-icon" *ngIf="!resetInput">
        <i class="material-icons">search </i>
      </div>
    </form>
  </div>
  <div class="pager">
    <div class="pager-text">{{ paginationText() }}</div>
    <div class="pager-button" [class.disabled]="backDisabled" (click)="moveBack()">
      <i class="ni ni-bold-left"></i>
    </div>
    <div class="pager-button" [class.disabled]="nextDisabled" (click)="moveNext()">
      <i class="ni ni-bold-right"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/data-table/data-table-footer/data-table-footer.component.html